var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArea = function SvgArea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#area_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.781 13.635a.751.751 0 0 0 0-1.062l-2.134-2.135a.762.762 0 0 0-1.083 0 .75.75 0 0 0 .01 1.05l.867.867h-8.21a1.585 1.585 0 0 1-1.586-1.586V2.56l.867.867a.75.75 0 1 0 1.06-1.06L3.424.219a.747.747 0 0 0-1.056 0L.219 2.366a.75.75 0 0 0-.01 1.05.765.765 0 0 0 1.082 0l.854-.857v8.21a3.085 3.085 0 0 0 3.085 3.085h8.211l-.867.867a.75.75 0 1 0 1.06 1.06l2.147-2.146ZM15.252 9.406a.75.75 0 0 0 .75-.75V3.084A3.09 3.09 0 0 0 12.917 0H7.344a.75.75 0 1 0 0 1.5h5.573a1.587 1.587 0 0 1 1.585 1.585v5.571a.75.75 0 0 0 .75.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.973 9.885a.56.56 0 0 0 .56-.56V7.008A1.76 1.76 0 0 0 7.57 5.722a1.757 1.757 0 0 0-1.938-.313.56.56 0 0 0-1.025.313v3.603a.56.56 0 1 0 1.121 0V7.008a.641.641 0 1 1 1.281 0v2.317a.56.56 0 0 0 1.121 0V7.008a.641.641 0 1 1 1.281 0v2.317a.56.56 0 0 0 .562.56Z",
    fill: "#1A181E",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.169 5.967h-.433l.507-.508c.235-.23.374-.542.39-.871v-.06a1.355 1.355 0 0 0-2.69-.215.528.528 0 0 0 1.043.167.298.298 0 0 1 .594.048v.014a.264.264 0 0 1-.082.17L11.089 6.12a.528.528 0 0 0 .373.901h1.707a.528.528 0 0 0 0-1.056Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "area_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};

export default SvgArea;